import React, { useEffect, useState } from "react";
import Cross from "../../../assets/icons/Cross";
import Plus from "../../../assets/icons/Plus";
import DefaultButton from "../../default-button/DefaultButton";
import InputField from "../../input-field/InputField";
import { ClubCategory, Department, MeetupsState, MeetupsTableItemType } from "../../../types";
import { accessGlobalMiscState } from "../../../stores/misc";
import { State } from "@hookstate/core";
import { useUniversalFindAll } from "../../../hooks/universal";
import { meetupStatuses } from "../../../misc/constants";
import { updateLocalStateRaw } from "../../../misc/utils";
import { HasRole } from "../../HasRole";
import DatePicker from "react-datepicker";
import { CustomDateInput } from "../../CustomDateInput";
import UploadDoc from "../../../assets/icons/UploadDoc";

type MeetupsControlsPropsType = {
  setIsAddFormOpen?: (value: boolean) => void;
  isAddFormOpen?: boolean;
  localState: State<MeetupsState>;
  onExport?: () => void;
};

const MeetupsControl = (props: MeetupsControlsPropsType) => {
  const clubCategories: ClubCategory[] = useUniversalFindAll('ActivityCategory');
  const departments: Department[] = useUniversalFindAll('Department');
  const localState = props.localState
  const onExport = props.onExport
  const state = localState.get();
  const { selectedCategoryId, selectedDepartmentId, selectedStatus, search, fromDate, toDate } = state;

  const openAddFrom = () => {
    props?.setIsAddFormOpen?.(true);
  };

  const reset = (key: string) => () => {
    updateLocalStateRaw(localState, key)("");
  }

  const resetDates = () => {
    localState.merge({
      fromDate: null,
      toDate: null
    })
  }

  const onInputChangeNative = (key: string) => (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
    localState.merge({
      [key]: e.target.value
    })
  }

  const onFormInputChangeDate = (key: string) => (date: Date | null) => {
    localState.merge({
      [key]: date
    })
  }

  return (
    <div className="flex flex-col gap-3 sm:gap-4 w-full">
      <div className="flex flex-col lg:flex-row gap-3 lg:gap-4 items-start lg:items-center w-full flex-wrap">
        <div className="w-full lg:flex-[2] lg:min-w-[200px] flex-shrink-0">
          <InputField
            type="text"
            placeholder="Поиск"
            value={search}
            handleChange={onInputChangeNative('search')}
          />
        </div>
        {!props.isAddFormOpen && (
          <>
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2 flex-shrink-0">
              <label htmlFor="department" className="text-xs sm:text-sm text-gray-700 whitespace-nowrap font-medium">
                Департамент
              </label>
              <div className="flex items-center gap-1.5">
                <select
                  id="department"
                  className="border border-gray-200 rounded-md px-2 py-1.5 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-valley-main bg-blue-100 opacity-[0.4] text-black min-w-[140px] w-full lg:w-auto"
                  value={selectedDepartmentId}
                  onChange={onInputChangeNative('selectedDepartmentId')}
                >
                  <option value="" selected>
                    Все
                  </option>
                  {departments.map((d) => (
                    <option value={d.id}>{d.title}</option>
                  ))}
                </select>
                {selectedDepartmentId && (
                  <DefaultButton
                    additionalStyle="text-red-500 bg-red-100 border-red-500 px-1.5 sm:px-2 hover:bg-red-200 flex-shrink-0 transition-colors"
                    Icon={Cross}
                    buttonText=""
                    onClick={reset("selectedDepartmentId")}
                  />
                )}
              </div>
            </div>
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2 flex-shrink-0">
              <label htmlFor="category" className="text-xs sm:text-sm text-gray-700 whitespace-nowrap font-medium">
                Категория
              </label>
              <div className="flex items-center gap-1.5">
                <select
                  id="category"
                  className="border border-gray-200 rounded-md px-2 py-1.5 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-valley-main bg-blue-100 opacity-[0.4] text-black min-w-[140px] w-full lg:w-auto"
                  value={selectedCategoryId}
                  onChange={onInputChangeNative('selectedCategoryId')}
                >
                  <option value="" selected>
                    Все
                  </option>
                  {clubCategories.map((c) => (
                    <option value={c.id}>{c.name}</option>
                  ))}
                </select>
                {selectedCategoryId && (
                  <DefaultButton
                    additionalStyle="text-red-500 bg-red-100 border-red-500 px-1.5 sm:px-2 hover:bg-red-200 flex-shrink-0 transition-colors"
                    Icon={Cross}
                    buttonText=""
                    onClick={reset('selectedCategoryId')}
                  />
                )}
              </div>
            </div>
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2 flex-shrink-0">
              <label htmlFor="status" className="text-xs sm:text-sm text-gray-700 whitespace-nowrap font-medium">
                Статус
              </label>
              <div className="flex items-center gap-1.5">
                <select
                  id="status"
                  className="border border-gray-200 rounded-md px-2 py-1.5 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-valley-main bg-blue-100 opacity-[0.4] text-black min-w-[140px] w-full lg:w-auto"
                  value={selectedStatus}
                  onChange={onInputChangeNative('selectedStatus')}
                >
                  <option value="" selected>
                    Все
                  </option>
                  {meetupStatuses.map((s) => (
                    <option value={s.value}>{s.label}</option>
                  ))}
                </select>
                {selectedStatus && (
                  <DefaultButton
                    additionalStyle="text-red-500 bg-red-100 border-red-500 px-1.5 sm:px-2 hover:bg-red-200 flex-shrink-0 transition-colors"
                    Icon={Cross}
                    buttonText=""
                    onClick={reset('selectedStatus')}
                  />
                )}
              </div>
            </div>
          </>
        )}
        <HasRole roles={['create_activities']}>
          {Boolean(props.setIsAddFormOpen) && !props.isAddFormOpen && (
            <DefaultButton
              additionalStyle="text-green-500 border-green-500 px-3 md:px-4 hover:bg-green-50 text-sm md:text-[15px] text-nowrap py-2 md:py-3 w-full lg:w-auto transition-all shadow-sm hover:shadow flex-shrink-0"
              Icon={Plus}
              buttonText="Создать мероприятие"
              onClick={openAddFrom}
            />
          )}
        </HasRole>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-start sm:items-center">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3">
          <span className="font-medium text-xs sm:text-sm leading-[15.4px] text-valley-gray whitespace-nowrap">
            Даты
          </span>
          <div className="flex flex-row items-center gap-2 text-valley-black flex-wrap">
            <DatePicker
              selected={fromDate}
              onChange={onFormInputChangeDate('fromDate')}
              customInput={<CustomDateInput hasTime={false} />}
              dateFormat="dd/MM/yyyy"
            />
            <DatePicker
              selected={toDate}
              onChange={onFormInputChangeDate('toDate')}
              customInput={<CustomDateInput hasTime={false} />}
              dateFormat="dd/MM/yyyy"
            />
            {(fromDate || toDate) && (
              <DefaultButton
                additionalStyle="text-red-500 bg-red-100 border-red-500 px-2 hover:bg-red-200 transition-colors"
                Icon={Cross}
                buttonText=""
                onClick={resetDates}
              />
            )}
          </div>
        </div>
        <DefaultButton
          onClick={onExport}
          additionalStyle="border-gray-500 text-gray-500 px-3 hover:bg-gray-50 w-full sm:w-auto transition-all shadow-sm hover:shadow"
          Icon={UploadDoc}
          buttonText="Выгрузить"
        />
      </div>
    </div>
  );
};

export default MeetupsControl;
